import React, {ChangeEventHandler} from 'react';
import {Translate} from "../../../components/util/translation.util";
import {Spin, Form, Input} from "antd";
import {TranslationDomainEnum} from "../../../types/enums";
import { LoadingOutlined } from '@ant-design/icons';

const antIcon = <LoadingOutlined style={{ fontSize: 18 }} spin />;

export const TextType: React.FC<{
    name: string,
    label: string,
    translationDomain?: TranslationDomainEnum,
    rules?: any,
    onChange?: ChangeEventHandler | undefined,
    onInput?: any,
    loading?: boolean,
    disabled?: boolean,
    warningMessage?: string,
    validateTrigger?: string,
}> = ({name, label, translationDomain, rules, onChange, loading = false, disabled= false, onInput, validateTrigger= 'onBlur' }) =>  (
    <Form.Item
        labelAlign={`left`}
        name={ name.split('.') }
        label={<Translate message={label} domain={translationDomain} />}
        htmlFor={ name }
        rules={rules}
        validateTrigger={validateTrigger}
    >
        <Input id={name} key={name} onInput={onInput} onChange={onChange} disabled={disabled} suffix={ loading && <Spin indicator={antIcon}  /> } />
    </Form.Item>
)
